import { render, staticRenderFns } from "./confirmarcobranza.vue?vue&type=template&id=5a82062e"
import script from "./confirmarcobranza.vue?vue&type=script&lang=js"
export * from "./confirmarcobranza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports